import type { EmjaeQuestion, EmjaeQuestionOption } from './types';

/**
 * Emjae's question from the backend's snake_case payload (a stream `data.question` or a conversation's
 * `pending_question`), or undefined when it has no request id: without one there is nothing to answer.
 */
export function questionFromPayload(payload: unknown): EmjaeQuestion | undefined {
  if (!payload || typeof payload !== 'object') return undefined;
  const raw = payload as Record<string, unknown>;
  const requestId = raw.request_id;
  if (typeof requestId !== 'string' || !requestId) return undefined;
  const options: EmjaeQuestionOption[] = [];
  for (const item of Array.isArray(raw.options) ? raw.options : []) {
    if (!item || typeof item !== 'object') continue;
    const option = item as Record<string, unknown>;
    if (typeof option.id !== 'string' || !option.id || typeof option.label !== 'string' || !option.label) continue;
    options.push({
      id: option.id,
      label: option.label,
      ...(typeof option.description === 'string' && option.description ? { description: option.description } : {}),
      ...(typeof option.style === 'string' && option.style ? { style: option.style } : {}),
    });
  }
  return { requestId, options, allowFreeform: raw.allow_freeform === true };
}
